/**
 * https://developer.zendesk.com/api-reference/widget-messaging/web/core/
 */
const webWidget = {
  isReady: () => typeof window.zE === 'function',

  show: () => {
    window.zE('messenger', 'show');
  },

  hide: () => {
    window.zE('messenger', 'hide');
  },

  open: () => {
    window.zE('messenger', 'open');
  },

  close: () => {
    window.zE('messenger', 'close');
  },

  showAndOpen: () => {
    webWidget.open();
    webWidget.show();
  },
};

export { webWidget };
